var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "wrap": "",
      "fill-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "calls pb-1"
  }, [_c('v-tabs', {
    attrs: {
      "color": "dark",
      "fixed-tabs": "",
      "slider-color": "cyan",
      "grow": "",
      "id": "callList"
    }
  }, [_vm.callDetail.id ? _c('v-tab', {
    key: "activecall",
    attrs: {
      "to": "/calls/active"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.activeCall')) + " (" + _vm._s(_vm.callDetail.call_remote_id) + ")\n        ")]) : _vm._e(), _c('v-tab', {
    key: "listcalls",
    attrs: {
      "to": "/calls/list"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$vuetify.t('$vuetify.calls.availableCalls')) + "\n        ")])], 1), _c('router-view')], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }